import { CommApiInstance } from "Utils/CommApiInstance";

const GameCupnApi = async (
    gameSvcCd:string,
    cupnCd:string,
    MembUUID:string|null,
    reCaptchaToken:string,
) => {
    return await CommApiInstance.post(`memb/${gameSvcCd}/cupn/reg`,{
        apiBody:{
            cupnCd: cupnCd,
            cptchTkn: reCaptchaToken,
        },
    })
    .then((Resp) => Resp.data);
}
export default GameCupnApi;